export default "__VITE_ASSET__Vzj1T7Sf__"